module.exports = __webpack_public_path__ + "img/grayRadio.d736d744.svg";